import { render, staticRenderFns } from "./RolleSC.vue?vue&type=template&id=4625123b&scoped=true&"
import script from "./RolleSC.vue?vue&type=script&lang=js&"
export * from "./RolleSC.vue?vue&type=script&lang=js&"
import style0 from "./RolleSC.vue?vue&type=style&index=0&id=4625123b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625123b",
  null
  
)

export default component.exports